import React, { Component, ReactNode } from "react";
import classnames from "classnames";

import { HStack, IHStackProps } from "@formant/ui/component/common/HStack";

import * as styles from "./RadioGroup.scss";
import { RadioOption } from "./RadioOption";

export interface IRadioOption {
    value: string;
    label?: ReactNode | string;
    extraLabel?: ReactNode;
    disabled?: boolean;
}

export interface IRadioGroupProps {
    name?: string;
    value?: string;
    options: IRadioOption[];
    className?: string;
    optionClassName?: string;
    onChange: (value: string) => void;
    vAlign?: IHStackProps["vAlign"];
}

export class RadioGroup extends Component<IRadioGroupProps> {
    public render() {
        const {
            name,
            value: selectedValue,
            options,
            className,
            optionClassName,
            onChange,
            vAlign = "center",
        } = this.props;
        const radios = options.map(
            ({ label, value, disabled, extraLabel }, index) => {
                return (
                    <RadioOption
                        key={`${name}.${index}`}
                        id={`${name}.${index}`}
                        name={name}
                        value={value}
                        checked={value === selectedValue}
                        disabled={disabled}
                        className={classnames(
                            styles["radio-option"],
                            optionClassName,
                        )}
                        extraLabel={extraLabel}
                        onChange={onChange}
                    >
                        {label || value}
                    </RadioOption>
                );
            },
        );

        return (
            <HStack
                vAlign={vAlign}
                className={classnames(styles["radio-group"], className)}
            >
                {radios}
            </HStack>
        );
    }
}
